import { useSearchParams } from "react-router-dom";
import { ENDPOINTS } from "../../../apiConfig";
import axiosRequest from "../../universal/axiosService";
import { datalist } from "framer-motion/client";
import { method } from "lodash";
import common from "../../../../utils/common";

const { encryptAll } = common;

const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;

export const fetchKultFetchApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.KULT_FETCH.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const fetchHotlistApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.HOTLIST.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const fetchCandidateApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE.GET_ALL,
    params: {
      ...params,
    },
  });
};
export const addCandidateApi = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE.ADD,
    data, // For POST requests i am using  "data" instead of "params"
  });
};

const urlMap = {
  Submission: ENDPOINTS.SUBMISSION.GET_TOTAL_COUNT_SUBMISSION,
  Interview: ENDPOINTS.INTERVIEW.GET_TOTAL_COUNT_INTERVIEWS,
  Placement: ENDPOINTS.PLACEMENT.GET_TOTAL_COUNT_PLACEMENTS,
  Candidate: ENDPOINTS.CANDIDATE.GET_TOTAL_COUNT_CANDIDATE,
};

export const fetchTotalCountApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: urlMap[params.coll],
    params: {
      ...params,
    },
  });
};

export const updateCandidateApi = async (uiid, data) => {
  const isFormData = data instanceof FormData;

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.CANDIDATE.UPDATE,
    params: {
      uiid,
      coll: "Candidate",
      uploadType: "multiple",
      field: "file",
    },
    data,
    //  Let Axios set multipart boundaries automatically
    headers: isFormData ? {} : { "Content-Type": "application/json" },
  });
};

export const uploadDocumentApi = async (formData, params = {}) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE.UPLOAD,
    params: {
      ...params, // query params like coll, uploadType, field
    },
    data: formData, //  FormData contains files
    headers: {
      "Content-Type": "multipart/form-data", // Let axios handle boundary automatically
    },
  });
};

export const fetchUsersApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.USEREF.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getTotalUserCountApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.USEREF.GET_TOTAL_COUNT,
    params: {
      ...params,
    },
  });
};

export const addJobContactApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.CONTACTS.ADD,
    data,
  });
};

export const fetchCompanyContactApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CONTACTS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addSubmissionDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.SUBMISSION.ADD,
    data,
  });
};

export const fetchSubmissionDetailsApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.SUBMISSION.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addInterviewDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTERVIEW.ADD,
    data,
  });
};

export const fetchInterviewDetailsApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTERVIEW.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addPlacementDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.PLACEMENT.ADD,
    data,
  });
};

export const getCandidateScore = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE.GET,
  });
};

export const handleAnalyzeApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE.ANALYZE,
    params: {
      ...params,
    },
  });
};

export const fetchCandidateVersionApi = async (params) => {
  return axiosRequest({
    url: ENDPOINTS.CANDIDATEVERSION.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const fetchResumeDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.OPTIMISERESUME.GET_ALL,
    data,
  });
};

export const deleteCandidateVersionApi = async (data) => {
  return axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.CANDIDATEVERSION.DELETE,
    data,
  });
};

export const getRecruiterAssignedCandidatedApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE.GET_TOTAL_USER_COUNT,
    params: {
      ...params,
    },
  });
};

export const BenchSalesResumeParser = async (formData) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.CANDIDATE.RESUME_PARSER}?uploadType=single`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getRecruitersUiidApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.USEREF.GET_ALL,
    params,
  });
};

export const updateContactApi = async (params) => {
  const { data, ...queryParams } = params;

  return axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.CONTACTS.UPDATE,
    params: queryParams,
    data,
  });
};

export const fetchIntegrationAccess = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.BS_INTEGRATION_ACCESS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getAllIntegrationsBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATION_BS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addIntegrationsBs = async (params) => {
  const { config, ...rest } = params?.payload;
  const payload = { ...rest, ...config };
  const data = { coll: params?.coll, payload };

  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTEGRATION_BS.ADD,
    data: data,
  });
};

export const updateIntegrationsBs = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATION_BS.UPDATE}?coll=Integrationbs&uiid=${params.uiid}`,
    data: {
      payload: params.payload,
    },
  });
};

export const deleteIntegrationBs = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.INTEGRATION_BS.DELETE}`,
    data: {
      coll: params.coll,
      uiid: params.uiid,
    },
  });
};

export const getAllIntegrationAccessBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATION_ACCESS_BS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      useAggregate: params.useAggregate,
      ref: params.ref,
      incl: params.incl,
      lim: params.lim,
      pg: params.pg,
      queryMode: params.queryMode,
    },
  });
};

export const addUsersIntegrationAccessBs = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTEGRATION_ACCESS_BS.ADD,
    data: params,
  });
};

export const updateIntegrationAccessStatusBs = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATION_ACCESS_BS.UPDATE}?coll=Integrationaccess&uiid=${params.uiid}`,
    data: {
      payload: params.payload,
    },
  });
};

export const addCreditHistoryBs = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CREDIT_HISTORY_BS.ADD,
    data: params,
  });
};

export const getAllCreditHistoryBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CREDIT_HISTORY_BS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getTotalMainCountApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTERVIEW.GET_TOTAL_MAIN_COUNT,
    params: {
      ...params,
    },
  });
};

export const verifyEmail = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CONTACTS.VERIFY,
    data: params,
  });
};

export const addCandidatePlatformCredentialApi = async (params) => {
  const { config, ...rest } = params?.payload || {};
  const payload = { ...rest, ...config };

  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE_PLATFORM_CREDENTIALS.ADD,
    params: {
      coll: "candidatePlatformCredential",
    },
    data: {
      coll: "candidatePlatformCredential",
      payload: payload,
    },
  });
};

export const fetchCandidatePlatformCredentialsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_PLATFORM_CREDENTIALS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const apolloAuthApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.BS_CONTACTS.AUTH,
    params: {
      ...params,
    },
  });
};

export const getCandidateDoc = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE.GET_DOC,
    params: {
      ...params,
    },
  });
};

export const getSettingsBs = async () => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.SETTINGS_BS.GET_ALL,
  });
};

export const getAssignedCandidateApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE.GET_TOTAL_USER_COUNT,
    params: {
      ...params,
    },
  });
};

export const getOnprojectCandidateAPI = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getCandidateById = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE.GET_BY_ID,
    params: {
      ...params,
    },
  });
};
